import React, { useEffect, useState } from "react";
import { arrowLeft } from "../../Components";
import { adminService } from "../../Services";


import CronMain from "./CronMain";
import CronDetail from "./CronDetail";

import { Toast } from "../../Components";


export default function Cron({ setAuth, setModal, NotifModul, profiles,
  setModalNotification }) {
  // eslint-disable-next-line
  const [ setselectDesc] = useState();
  const [modalUrl] = useState(null);
  const [sortOrder] = useState('desc');
  const [toastList, setToastList] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [cronDetails, setCronDetails] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize] = useState(10);
  const [paginationData, setPaginationData] = useState({});
  const [tab, setTab] = useState("main");
  const [tabData, setTabData] = useState();
  const addToast = (data) => {
    const newToastList = [...toastList];
    newToastList.push({ ...data, id: `${Date.now()}-${toastList.length}` });
    setToastList(newToastList);
  };

  const onPaginate = page => {
    setPage(page);
  };


  useEffect(() => {
    async function fetchCronDetails() {
      try {
        setIsLoaded(false);
        const cronData = await adminService.getCronDetails({
          page: page,
          pageSize: pageSize
        });
        setCronDetails(cronData.data);
        setPaginationData(cronData.pagination);
      } catch (err) {
        console.log(err.message);
        // addToast({
        //   error: true,
        //   msg: err.message || 'Failed to fetch cron details',
        //   id: `${Date.now()}-${toastList.length}`
        // });
        // Keep existing data instead of clearing it
      } finally {
        setIsLoaded(true);
      }
    }
    fetchCronDetails();
  }, [page, sortOrder]);

  // const changeMediumDesc = (item) => {
  //   setselectDesc(item.value);
  // };
  // const sortList = () => {
  //   setSortOrder(sortOrder === 'desc' ? 'asc' : 'desc');
  // };
  useEffect(() => {
    if (modalUrl) {
      document.body.classList.add("active");
    } else {
      document.body.classList.remove("active");
    }
  }, [modalUrl]);
  return (
    <>
      <div className="main">
        <div className="main__inner">
          {tab === "cronDetail" &&
            <>
              <button
                className="button tertiary big"
                onClick={() => setTab("main")}
              >
                {arrowLeft} Back
              </button>

            </>
          }
          <div className="url !mt-2">
            <div className="url__table-title cronlist">
              {tab === "main" &&
                <h4>Cron Details</h4>}
              {tab === "cronDetail" &&
                <>

                  <h4>{tabData.label}</h4>
                </>
              }
              <div className="url__table-title-inner">
                {/*} <SelectInput
                  list={selectDescList}
                  selected={selectDescList[0]}
                  onChange={changeMediumDesc}
                />
                <SearchInput
                  type="text"
                  icon={searchIcon}
                  placeholder="Search"
                    />*/}

              </div>
            </div>
            {tab === "main" &&
              <CronMain onPaginate={onPaginate} cronDetails={cronDetails} isLoaded={isLoaded} setTab={setTab} setTabData={setTabData} paginationData={paginationData} />
            }
            {tab === "cronDetail" &&
              <CronDetail tabData={tabData} addToast={addToast} toastList={toastList} />
            }
          </div>
        </div>
      </div>
      {toastList && (
        <Toast
          type="rate"
          addClass="sm"
          list={toastList}
          setList={setToastList}
        />
      )}


    </>
  );
}
